import { render, staticRenderFns } from "./filter-posts-content.vue?vue&type=template&id=b4b27a00&scoped=true"
import script from "./filter-posts-content.vue?vue&type=script&lang=js"
export * from "./filter-posts-content.vue?vue&type=script&lang=js"
import style0 from "./filter-posts-content.vue?vue&type=style&index=0&id=b4b27a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b27a00",
  null
  
)

/* custom blocks */
import block0 from "./filter-posts-content.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports